import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './styles/globals.css'

Vue.config.productionTip = false

// 全局API基础URL配置 - 使用相对路径通过代理转发
Vue.prototype.$apiBaseUrl = process.env.NODE_ENV === 'production' 
  ? (process.env.VUE_APP_API_BASE_URL || '/api') 
  : '/api'

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')